import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {NavbarService} from './shared/services/navbar.service';

export const customGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  let navbarService = inject(NavbarService);
  if (state.url.includes("enrollment")) {
    navbarService.show(true);
  } else if (state.url.includes("home")) {
    navbarService.show(true);
  } else {
    navbarService.show(false);
  }
  return true;

}
